export enum MobileStatusBarMode {
    Light = 'light',
    Dark = 'dark',
    Default = 'default',
}
